import React from 'react'
import {Header, List, Message} from 'semantic-ui-react'

const CreateMockFromContract = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Create Mock From Contract</Header>
      <Message>
        <Message.Header>A Few Things To Remember</Message.Header>
        <Message.List>
          <Message.Item>The title specified in your contract's info section will be the service's name</Message.Item>
          <Message.Item>The version specified in your contract's info section will be the version created in the
            mock</Message.Item>
          <Message.Item>If a title and/or version already exist the contract upload will act as an update instead of an
            insert</Message.Item>
        </Message.List>
      </Message>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Move mouse to upper right hand section of screen</List.Item>
        <List.Item>2. Click your account dropdown</List.Item>
        <List.Item>3. Move mouse to left side of screen and click "Upload Contract" button</List.Item>
        <List.Item>4. Paste Open API Specification to text area</List.Item>
        <List.Item>5. Click "Upload"</List.Item>
      </List>
    </div>
  )
}

export {CreateMockFromContract}

export default CreateMockFromContract